import {
  DSFlex,
  DSFlexProps,
  DSIcon,
  DSIconColorType,
  DSIconName,
  DSIconSize,
  DSSpacer,
  DSText,
  DSTextColorType,
  DSTextFontFamilyType,
  DSTextVariantType,
} from '@zoe/ds-web'

type TextAndIconProps = {
  text: string
  textVariant: DSTextVariantType
  textWeight: DSTextFontFamilyType
  textColour: DSTextColorType
  iconName: DSIconName
  iconSize: DSIconSize
  iconPosition: 'left' | 'right'
  iconColour?: DSIconColorType
  iconAndTextAlignment?: DSFlexProps['alignItems']
}

/**
 * @deprecated This component is deprecated and will be removed soon.
 * Please use DSTextAndIcon from @zoe/ds-web instead.
 */
export const DSTextAndIcon = ({
  text,
  textColour,
  textVariant,
  textWeight,
  iconName,
  iconSize,
  iconPosition,
  iconColour,
  iconAndTextAlignment = 'center',
}: TextAndIconProps) => {
  return (
    <DSFlex direction="row" justifyContent="flex-start" alignItems={iconAndTextAlignment}>
      <DSFlex direction={iconPosition === 'right' ? 'row' : 'row-reverse'} alignItems={iconAndTextAlignment}>
        <DSText as="span" variant={textVariant} weight={textWeight} color={textColour}>
          {text}
        </DSText>
        <DSSpacer size={8} direction="horizontal" />
        <DSIcon name={iconName} size={iconSize} color={iconColour} />
      </DSFlex>
    </DSFlex>
  )
}
